import { CrudServiceBase } from './CrudServiceBase';
import { FeeSheetRuleDto } from '@/models/Fees/FeeSheetRuleDto';

export class FeeSheetRuleService extends CrudServiceBase<FeeSheetRuleDto> {
  constructor(baseUrl: string) {
    super(baseUrl);
  }

  async getAll() : Promise<string[]> {
    return await this.client.get('');
  }
}